import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountInfo, MFASetupResult } from '../models';
import { ServicesHelper } from '../helpers';

@Injectable()
export class AccountService {
  private url: string;

  constructor(private httpClient: HttpClient, @Inject('API_URL') private apiUrl: string) {
    this.url = `${apiUrl}account/`;
  }

  getAccountInfo(): Observable<AccountInfo> {
    const url: string = this.url + 'GetAccountInfo';
    const response: Observable<AccountInfo> = this.httpClient.get<AccountInfo>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
    return response;
  }

  setup2FAAuthenticator() {
    const url: string = this.url + 'Setup2FA';
    const response: Observable<MFASetupResult> = this.httpClient.post<MFASetupResult>(url, {}, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
    return response;
  }

  validate2FACode(code: string) {
    const url: string = this.url + 'Validate2FACode';
    const response: Observable<boolean> = this.httpClient.post<boolean>(url, { code: code }, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
    return response;
  }

  save2FAConfig(enabled: boolean) {
    const url: string = this.url + `Confirm2FASetup?enabled=${enabled}`;
    const response: Observable<boolean> = this.httpClient.put<boolean>(url, {}, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
    return response;
  }

  public getUserInfo(): Observable<any> {
    const url: string = this.url + 'GetUserInfo';
    const response: Observable<any> = this.httpClient.get(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
    return response;
  }
}
